import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ClientStudyRequest } from '@app/models/clientStudyRequest.model';
import { ClientStudyResponse } from '@app/models/clientStudyResponse.model';
import { UploadDocumentsService } from '@app/services/upload-documents.service';
import { ModelEmailLoadDocumentsRequest, tagsMailsModel } from '@app/models/emailLoadDocuments.model';
import { ReturnDocumentsLoadFlag } from '@app/models/flagLoadDocuments.model';
import { ModalService } from '@services/modal.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CONSTANTS } from "@app/config/constants";

interface FileData {
  id?: any,
  source?: string,
  user?: string,
  documentType?: any,
  document?: any,
  originalName?: string,
  creationDate?: any,
  category?: string,
  infoFile?: string,
  originalPath?: any,
  originalFinalName?: any,
  resourceId?: any
}
@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnChanges {

  public actualDate = new Date();
  public checked: boolean = false;
  public dataFileList = [];
  public fileData: FileData;
  public fileDataMail: ModelEmailLoadDocumentsRequest;
  public filesUp: boolean[] = Array(1).fill(false);
  public numberFiles: boolean = false;
  public promiseList = [];
  public count = 0;
  public opc = 0;
  public uploadedDocs = 0;
  
  @Input('clientStudy') clientStudyForm: ClientStudyRequest;
  @Input() clientStudyResponse: ClientStudyResponse;
  @Input() enableButton: boolean = false;
  @Input() objFileTypes: Array<any>;
  @Input() quotaValue: number = 0;
  @Input() response: any;
  @Output() chargeResult: EventEmitter<File[]> = new EventEmitter();
  @Output() close: EventEmitter<File[]> = new EventEmitter();
  @Output() confirm: EventEmitter<object> = new EventEmitter();
  @Output() fileArray: EventEmitter<boolean[]> = new EventEmitter();
  @Output() numberDocuments: EventEmitter<number> = new EventEmitter();
  @Output() removeFileEvent: EventEmitter<number> = new EventEmitter();
  
  constructor(
    public modalService: ModalService,
    public spinner: NgxSpinnerService,
    public toastr: ToastrService,
    private uploadDocumentsService: UploadDocumentsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.quotaValue && changes.quotaValue !== undefined) {
      try {
        if (changes.quotaValue.previousValue != changes.quotaValue.currentValue) {
          if (this.clientStudyForm.quotaValue > 20000000 && this.clientStudyForm.quotaValue <= 50000000) {
            this.filesUp = Array(1).fill(false);
          } else if (this.clientStudyForm.quotaValue > 50000000 && this.clientStudyForm.quotaValue <= 100000000) {
            this.filesUp = Array(2).fill(false);
          } else if (this.clientStudyForm.quotaValue > 100000000) {
            this.filesUp = Array(3).fill(false);
          }
          this.fileArray.emit(this.filesUp)
        }
      } catch (error) { 
        console.error(error);
      }
    }
  }
  
  get getName() : string {
    const { companyName, clientType, legalRepresentativeFirstName, legalRepresentativeFistLastName} = this.clientStudyForm;
    return clientType === CONSTANTS.CLIENT_STUDY.LEGAL ? companyName.toUpperCase() : legalRepresentativeFirstName ? `${legalRepresentativeFirstName.toUpperCase()} ${legalRepresentativeFistLastName.toUpperCase()}` : 'N/A'
  }

  chargeDoc(event) {
    this.chargeResult.emit(event);
  }

  createArrayFile(objectFile: any, idx: number) {
    this.uploadedDocs += 1;
    this.numberFiles = true;
    this.promiseList[idx] = (this.toBase64(objectFile.params));
    this.dataFileList[idx] = (objectFile.params);
    this.uploadedFile(idx);
  }

  async toBase64(file: File) {
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
    return base64;
  }

  uploadedFile(idx) {
    this.numberDocuments.emit(idx)
  }

  onRemove(event, idx) {
    this.removeFileEvent.emit(idx)
    let position = this.promiseList.indexOf(event)

    if (this.promiseList.length === 0) return 
    else {
      if (position == -1) {
        this.promiseList.splice(idx, 1, '');
        this.dataFileList.splice(idx, 1, '');
      } else {
        this.promiseList.splice(position, idx, '');
        this.dataFileList.splice(position, idx, '');
      }
    }
    this.uploadedDocs -= 1;
  }

  async sendInfo(event?): Promise<void> {
    let csf = this.clientStudyForm;
    this.spinner.show();
    if (!this.checked) {
      if (this.promiseList.length === 0) return
      else {
        Promise.all(this.promiseList).then((filesBase64) => {
          filesBase64.forEach((file, index) => {
            if (this.opc === 0) {
              this.fileData = {
                id: null,
                source: "CovifacturaWeb",
                documentType: csf.clientType === CONSTANTS.CLIENT_STUDY.LEGAL ? "N" : csf.sellerDocumentType,
                document: csf.sellerDocumentNumber,
                originalPath: null,
                originalFinalName: this.dataFileList[index].name,
                resourceId: this.clientStudyResponse.code,
                user:
                  csf.clientType === CONSTANTS.CLIENT_STUDY.LEGAL
                    ? csf.companyName
                    : csf.legalRepresentativeFirstName +
                      " " +
                      csf.legalRepresentativeFistLastName,
                infoFile: file.split(",")[1],
                category: "SOLICITUD CUPO",
                originalName: this.dataFileList[index].name.split('.')[0],
              }
              this.uploadDocumentsService.sendDocuments(this.fileData).subscribe({
                next: (response: any) => {
                  console.log(response);
                },
                complete: () => {
                  this.count = this.count + 1;
                  if (this.lengthDocuments() == this.count) {
                    this.sendUploadDocumentsFlag();
                  }
                },
                error: (err) => {
                  this.spinner.hide();
                  this.toastr.error(err.error.message, "", {
                    timeOut: 4000,
                  });
                },
              });
            } else if (this.opc == 1) window.location.reload();
          });
        });
      }
    } else {
      this.sendInfoMail();
    }
  }

  sendUploadDocumentsFlag() {
    const flagBody = {
      radicado: this.clientStudyResponse.code,
      numeroDocumentos: this.lengthDocuments(),
    };

    this.uploadDocumentsService.saveDocumentUploadFlag(flagBody).subscribe({
      next: (response: ReturnDocumentsLoadFlag) => {
        console.log(response);
      },
      complete: () => {
        this.spinner.hide();
        this.opc = 1;
      },
      error: (err) => {
        this.spinner.hide();
        console.error(err);
      }
    });
  }

  lengthDocuments(): number {
    let numberOfDocs: number = 0;
    this.objFileTypes.forEach((file) => {
      if (this.response["MENSAJE_INTERNO "].length >= file.lengthMsg) {
        numberOfDocs += 1;
      }
    });
    return numberOfDocs;
  }

  sendInfoMail() {
    let longitud = [];

    for (let index = 0; index < this.objFileTypes.length; index++) {
      if (
        this.response["MENSAJE_INTERNO "].length >=
        this.objFileTypes[index].lengthMsg
      ) {
        longitud.push(this.objFileTypes[index].name);
      }
      else if (this.opc == 0) this.opc = 2;
    }
    
    const linkLanding = environment.uploadDocumentsUrl;
    const fileDataMail: ModelEmailLoadDocumentsRequest = new ModelEmailLoadDocumentsRequest();
    
    fileDataMail.asunto = "Cargue de documentos";
    fileDataMail.destinatarios = environment.production
      ? [
        this.clientStudyForm.email,
        "claudia.grau@covinoc.com",
        "ivan.lopez@covinoc.com",
      ]
      : [
        this.clientStudyForm.email,
        "jeison.munoz@covinoc.com",
        "elver.acosta@covinoc.com",
      ];
    fileDataMail.idPlantilla = 69418;
    fileDataMail.tagsCorreo = [
      new tagsMailsModel("Nombre", this.getName),
      new tagsMailsModel("DOC1", longitud.join(' <br> ')),
      new tagsMailsModel("ID_RECURSO", linkLanding + this.clientStudyResponse.code + '/' + longitud.length),
    ]

    this.useEmailService(fileDataMail, 2);
  }

  useEmailService(dataEmail: ModelEmailLoadDocumentsRequest, opc: number) {
    this.spinner.show();
    this.uploadDocumentsService.sendMails(dataEmail).subscribe({
      next: (response: any) => {
        console.log(response);
      },
      complete: () => {
        this.spinner.hide();
        this.opc = opc;
      },
      error: (err) => {
        this.spinner.hide();
        console.error(err);
        this.toastr.error(err.error.message, "", {
          timeOut: 4000,
        });
      },
    });
  }

  accept() {
    this.confirm.emit();
    this.close.emit();
    window.location.reload();
  }

  ngOnDestroy() {
    this.modalService.close();
  }
}